// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignUp_SignUp__jxtKl {
  width: 50%;

  display: flex;

  flex-flow: column;

  justify-content: center;

  margin: auto;
}

.SignUp_SignupForm__gYbxC {
  width: 340px;

  min-height: 339px;

  margin: auto;

  /* padding: 1%; */

  background-color: #efeeed;

  border: none;

  border-radius: 20px;
}
.SignUp_formstyle__m\\+wvm {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SignUp_SocialIcon__1UhKB {
  display: flex;
  flex-direction: column; /* or column, depending on your layout */
  justify-content: center;
  align-items: center;
}

.SignUp_SignupFormElemnts__wGo\\+U {
  width: 86%;

  margin-top: 8%;

  /* margin-left: 10%; */

  border-bottom: 2px solid #a9a8a6;
}

.SignUp_DefaultCommunity__QcUJT {
  width: 86%;

  margin-top: 8%;

  /* margin-left: 10%; */

  border-bottom: 2px solid #a9a8a6;

}

.SignUp_SignupForm__gYbxC input {
  /* border: 0;

  background-color: transparent; */

  font-size: 18px;
}

.SignUp_textField__RNnfF {
  width: 100%;
}

.SignUp_SignupForm__gYbxC select {
  width: 100%;
  border: 0;
  background-color: transparent;
  font-size: 18px;
}

.SignUp_SignupForm__gYbxC select:focus {
  outline: none;
}

option {
  color: black;
}

/* .SignupForm select:optional {
  color: #a9a8a6;
  font-size: 18px;
} */

.SignUp_DefaultCommunity__QcUJT select:optional {
  color: #000000;
}

.SignUp_SignupForm__gYbxC input:focus {
  /* outline: none; */
  font-family: Arial;
  font-size: 18px;
}

.SignUp_SignupButton__MSTwO {
  width: 86%;

  margin: 0px 30px 20px 30px;

  padding: 10px 30px;

  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);

  border: none;

  border-radius: 20px;

  color:white;

  font-size: 16px;

  font-weight: 300;

  text-transform: capitalize;

  cursor: pointer;

  transition: all 0.2s ease-in-out;
}

.SignUp_SignupButton__MSTwO:disabled {
  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);

  color: #ffffff;

  cursor: not-allowed;

  opacity: 10;
}

.SignUp_Changesignin__O3w15 {
  text-align: center;
  position: relative;
  margin: 10px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SignUp_Changesignin__O3w15 span {
  background: #fff;

  display: inline-block;

  padding: 0 10px;

  position: relative;
}
.SignUp_line__MuNFB {
  width: 38%;
  height: 1.2px;
  background-color: #7a7a7a;
}

.SignUp_SocailSignIn__I0zDW {
  width: 236px;

  padding: 8px;

  display: flex;

  justify-content: center;

  justify-items: center;

  cursor: pointer;

  border-radius: 20px;

  margin: 0px auto 20px auto;

  text-align: center;
}

.SignUp_SocailImage__0InP5 {
  width: 30px;

  margin-left: 10px;
}

.SignUp_ErrorMsg__\\+SKfh {
  visibility: visible;

  margin: 0px;

  padding-top: 5px;
  padding-bottom: 0px;

  font-size: 12px;

  color: rgb(230, 79, 79);

  text-align: center;
}

.SignUp_TandC__0PZjo {
  width: 86%;

  font-size: 10px;

  /* border: 1px solid ; */

  margin: 20px auto 0px auto;

  text-align: center;
}

.SignUp_TandC__0PZjo p {
  font-size: 10px;
}

.SignUp_TandC__0PZjo span {
  color: #4795de;

  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/SignUp/SignUp.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;;EAEV,aAAa;;EAEb,iBAAiB;;EAEjB,uBAAuB;;EAEvB,YAAY;AACd;;AAEA;EACE,YAAY;;EAEZ,iBAAiB;;EAEjB,YAAY;;EAEZ,iBAAiB;;EAEjB,yBAAyB;;EAEzB,YAAY;;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,wCAAwC;EAChE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;;EAEV,cAAc;;EAEd,sBAAsB;;EAEtB,gCAAgC;AAClC;;AAEA;EACE,UAAU;;EAEV,cAAc;;EAEd,sBAAsB;;EAEtB,gCAAgC;;AAElC;;AAEA;EACE;;kCAEgC;;EAEhC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;;EAEV,0BAA0B;;EAE1B,kBAAkB;;EAElB,0EAA0E;;EAE1E,YAAY;;EAEZ,mBAAmB;;EAEnB,WAAW;;EAEX,eAAe;;EAEf,gBAAgB;;EAEhB,0BAA0B;;EAE1B,eAAe;;EAEf,gCAAgC;AAClC;;AAEA;EACE,0EAA0E;;EAE1E,cAAc;;EAEd,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;;EAEhB,qBAAqB;;EAErB,eAAe;;EAEf,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,aAAa;;EAEb,uBAAuB;;EAEvB,qBAAqB;;EAErB,eAAe;;EAEf,mBAAmB;;EAEnB,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;;EAEnB,WAAW;;EAEX,gBAAgB;EAChB,mBAAmB;;EAEnB,eAAe;;EAEf,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;;EAEV,eAAe;;EAEf,wBAAwB;;EAExB,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,eAAe;AACjB","sourcesContent":[".SignUp {\r\n  width: 50%;\r\n\r\n  display: flex;\r\n\r\n  flex-flow: column;\r\n\r\n  justify-content: center;\r\n\r\n  margin: auto;\r\n}\r\n\r\n.SignupForm {\r\n  width: 340px;\r\n\r\n  min-height: 339px;\r\n\r\n  margin: auto;\r\n\r\n  /* padding: 1%; */\r\n\r\n  background-color: #efeeed;\r\n\r\n  border: none;\r\n\r\n  border-radius: 20px;\r\n}\r\n.formstyle {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.SocialIcon {\r\n  display: flex;\r\n  flex-direction: column; /* or column, depending on your layout */\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.SignupFormElemnts {\r\n  width: 86%;\r\n\r\n  margin-top: 8%;\r\n\r\n  /* margin-left: 10%; */\r\n\r\n  border-bottom: 2px solid #a9a8a6;\r\n}\r\n\r\n.DefaultCommunity {\r\n  width: 86%;\r\n\r\n  margin-top: 8%;\r\n\r\n  /* margin-left: 10%; */\r\n\r\n  border-bottom: 2px solid #a9a8a6;\r\n\r\n}\r\n\r\n.SignupForm input {\r\n  /* border: 0;\r\n\r\n  background-color: transparent; */\r\n\r\n  font-size: 18px;\r\n}\r\n\r\n.textField {\r\n  width: 100%;\r\n}\r\n\r\n.SignupForm select {\r\n  width: 100%;\r\n  border: 0;\r\n  background-color: transparent;\r\n  font-size: 18px;\r\n}\r\n\r\n.SignupForm select:focus {\r\n  outline: none;\r\n}\r\n\r\noption {\r\n  color: black;\r\n}\r\n\r\n/* .SignupForm select:optional {\r\n  color: #a9a8a6;\r\n  font-size: 18px;\r\n} */\r\n\r\n.DefaultCommunity select:optional {\r\n  color: #000000;\r\n}\r\n\r\n.SignupForm input:focus {\r\n  /* outline: none; */\r\n  font-family: Arial;\r\n  font-size: 18px;\r\n}\r\n\r\n.SignupButton {\r\n  width: 86%;\r\n\r\n  margin: 0px 30px 20px 30px;\r\n\r\n  padding: 10px 30px;\r\n\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n\r\n  border: none;\r\n\r\n  border-radius: 20px;\r\n\r\n  color:white;\r\n\r\n  font-size: 16px;\r\n\r\n  font-weight: 300;\r\n\r\n  text-transform: capitalize;\r\n\r\n  cursor: pointer;\r\n\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.SignupButton:disabled {\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n\r\n  color: #ffffff;\r\n\r\n  cursor: not-allowed;\r\n\r\n  opacity: 10;\r\n}\r\n\r\n.Changesignin {\r\n  text-align: center;\r\n  position: relative;\r\n  margin: 10px 0px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.Changesignin span {\r\n  background: #fff;\r\n\r\n  display: inline-block;\r\n\r\n  padding: 0 10px;\r\n\r\n  position: relative;\r\n}\r\n.line {\r\n  width: 38%;\r\n  height: 1.2px;\r\n  background-color: #7a7a7a;\r\n}\r\n\r\n.SocailSignIn {\r\n  width: 236px;\r\n\r\n  padding: 8px;\r\n\r\n  display: flex;\r\n\r\n  justify-content: center;\r\n\r\n  justify-items: center;\r\n\r\n  cursor: pointer;\r\n\r\n  border-radius: 20px;\r\n\r\n  margin: 0px auto 20px auto;\r\n\r\n  text-align: center;\r\n}\r\n\r\n.SocailImage {\r\n  width: 30px;\r\n\r\n  margin-left: 10px;\r\n}\r\n\r\n.ErrorMsg {\r\n  visibility: visible;\r\n\r\n  margin: 0px;\r\n\r\n  padding-top: 5px;\r\n  padding-bottom: 0px;\r\n\r\n  font-size: 12px;\r\n\r\n  color: rgb(230, 79, 79);\r\n\r\n  text-align: center;\r\n}\r\n\r\n.TandC {\r\n  width: 86%;\r\n\r\n  font-size: 10px;\r\n\r\n  /* border: 1px solid ; */\r\n\r\n  margin: 20px auto 0px auto;\r\n\r\n  text-align: center;\r\n}\r\n\r\n.TandC p {\r\n  font-size: 10px;\r\n}\r\n\r\n.TandC span {\r\n  color: #4795de;\r\n\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SignUp": `SignUp_SignUp__jxtKl`,
	"SignupForm": `SignUp_SignupForm__gYbxC`,
	"formstyle": `SignUp_formstyle__m+wvm`,
	"SocialIcon": `SignUp_SocialIcon__1UhKB`,
	"SignupFormElemnts": `SignUp_SignupFormElemnts__wGo+U`,
	"DefaultCommunity": `SignUp_DefaultCommunity__QcUJT`,
	"textField": `SignUp_textField__RNnfF`,
	"SignupButton": `SignUp_SignupButton__MSTwO`,
	"Changesignin": `SignUp_Changesignin__O3w15`,
	"line": `SignUp_line__MuNFB`,
	"SocailSignIn": `SignUp_SocailSignIn__I0zDW`,
	"SocailImage": `SignUp_SocailImage__0InP5`,
	"ErrorMsg": `SignUp_ErrorMsg__+SKfh`,
	"TandC": `SignUp_TandC__0PZjo`
};
export default ___CSS_LOADER_EXPORT___;
